<template>
  <DataGetter
    :url="url"
    :params="{ CODE_INDICATOR: 'PRICE CONVERTED', Country: country }"
    v-slot="{ data }"
    :child-element-type="null"
  >
    <Chart
      v-if="data && data.length > 0"
      :title="title"
      units="USD/MWh"
      :half="half"
      :series="formatData(data)"
      :chartOptions="{
        chart: {
          height: 400,
          spacing: 10,
        },
        xAxis: {
          type: 'category',
        },
      }"
      palette="tints"
    ></Chart>
  </DataGetter>
</template>

<script>
import { DataGetter } from "@international-energy-agency/vue-ui";
import { Chart } from "@international-energy-agency/vue-ui/highcharts";
export default {
  components: { DataGetter, Chart },
  props: {
    country: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      default: "https://api.iea.org/prices",
      required: false,
    },
    half: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      years: "",
    };
  },
  computed: {
    title() {
      const { country, years } = this;
      return `${country} energy profile, ${years}`;
    },
  },
  methods: {
    // Merge data by fuel, year and tax
    formatData(data) {
      if (!data || data.length === 0) return [];
      const years = [];
      const fuels = [];
      const currencies = [];
      for (const row of data) {
        if (!years.includes(row.CODE_YEAR)) years.push(row.CODE_YEAR);
        if (!fuels.includes(row.Product)) fuels.push(row.Product);
        if (!currencies.includes(row.Currency)) currencies.push(row.Currency);
      }
      this.years = years.join(" vs. ");
      return years.reduce((series, year, i) => {
        currencies.forEach((currency, j) => {
          series.push({
            name: `${currency} in ${year}`,
            colorIndex: i * 3 + j,
            data: fuels.map((fuel) => [
              fuel,
              data.find(
                (row) =>
                  row.Currency === currency &&
                  row.CODE_YEAR === year &&
                  row.Product === fuel
              )?.Value,
            ]),
            stack: year,
          });
        });
        return series;
      }, []);
    },
  },
};
</script>

<style scoped>
.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>